export function renderGroupFieldLayoutTemplate({
  heading,
  indent,
  columnsGrid,
  groupFields
}: {
  heading: string
  indent: string
  columnsGrid: string
  groupFields: string
}): string {
  return `
${heading}${indent}  <div className="grid ${columnsGrid} gap-5">
${groupFields}
${indent}</div>`
}
